__turbopack_context__.v({
  "list": "v7mGtW_list",
  "panel": "v7mGtW_panel",
  "tab": "v7mGtW_tab",
  "tabLabel": "v7mGtW_tabLabel",
});
